import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { TRUCK_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 車両のインポート履歴の検索条件
 */
export const truckImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(TRUCK_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type TruckImportJobsSearch = InferOutput<
  typeof truckImportJobsSearchSchema
>
